import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugDoxepin} from "./TextDrugDoxepin"


export default function Doxepin() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
     <ButtonsText onClick={handleOpen} name='Doxepin' size='large' color='common.white' />
    
    <CustomDialog open={open} onClose={handleClose}

        title="Doxepin - PGx Recommendation"
        content={ <TextDrugDoxepin />}

        />

</>
)}